import { useObserver } from "mobx-react-lite"
import { authStore, User } from "@/stores/authStore"

export function useAuth() {
  return useObserver(() => ({
    user: authStore.user,
    isAuthenticated: authStore.isAuthenticated,
    login: authStore.login.bind(authStore),
    logout: authStore.logout.bind(authStore),
    setUser: authStore.setUser.bind(authStore),
    clearUser: authStore.clearUser.bind(authStore),
    handleAuthError: authStore.handleAuthError.bind(authStore),
    updateUserProfile: authStore.updateUserProfile.bind(authStore),
  }))
}

export type { User }
export type { UserRole } from "@/stores/authStore"
export { authStore }
